import React, { useState } from 'react'
import { FileDropBox } from '../../../../components/File/File'
import Button from '../../../../components/Button/Button'

const thumb = {
  display: 'inline-flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  width: 200,
  height: 200,
  padding: 4,
  boxSizing: 'border-box',
}

const img = {
  display: 'block',
  borderRadius: 8,
  maxWidth: '100%',
  height: 'auto',
}

export default function UnsubscribeAssets({ presentImage, onFile }) {
  const [logoFile, setLogoFile] = useState(presentImage)
  const remove = () => {
    onFile('')
    setLogoFile('')
  }

  const uploadFile = async (file) => {
    const reader = new FileReader()
    reader.onload = async () => {
      const binaryStr = reader.result
      const base64string = await Buffer.from(binaryStr).toString('base64')
      const imageUri = `data:${file.type};base64,${base64string}`
      onFile(imageUri)
      await setLogoFile(imageUri)
    }
    reader.readAsArrayBuffer(file)
    // }
  }

  return (
    <div>
      {logoFile ? (
        <div>
          <h3>Logo Image</h3>
          <div style={thumb}>
            <img src={logoFile} alt="logoImage" style={img} />
          </div>
          <Button variant="primary" onClick={remove} label="Remove" />
        </div>
      ) : (
        <div>
          <h2>Upload Logo Image:</h2>
          <FileDropBox onDrop={uploadFile} fileSize={1048576} />
        </div>
      )}
    </div>
  )
}

UnsubscribeAssets.defaultProps = {
  presentImage: '',
}
